import { Suspense } from 'react'

import { AppRouter } from './router/AppRouter'
import { Toaster } from 'react-hot-toast'
import Loader from './components/Loader'

function App() {
  return (
    <div className="relative h-full bg-white/5 antialiased">
      <div className="absolute inset-[15%] block rounded-full bg-white/5 blur-3xl"></div>
      <Suspense
        fallback={
          <div className="flex h-full w-full items-center justify-center">
            <Loader />
          </div>
        }
      >
        <div className="relative h-full">
          <AppRouter />
        </div>
      </Suspense>
      <Toaster position="top-center" toastOptions={{ className: '!bg-neutral-900/95 !text-white' }} />
    </div>
  )
}

export default App
